import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  border-top: 1px solid ${(props) => props.theme.colors.previewComponentDivisorColor};
  padding-top: 16px;
  padding-bottom: 17px;
  margin-top: 26px;

  color: ${(props) => props.theme.colors.previewComponentLabelColor};
`;

export const OptionsWrapper = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  width: 100%;

  margin-top: 16px;
  margin-bottom: 24px;

  min-height: 14px;
  
  @media(max-width: 526px) {
    & {
      min-height: 50px;
    }

    & div {
      flex: 1;
    }
  }
`;

export const OptionContainer = styled.div`
  display: inline-flex;
  margin-right: 24px;
`;

export const Option = styled.input`
  margin-right: 12px;
  border-radius: 2px;
  appearance: none;
  border: 1px solid ${(props) => props.theme.colors.previewComponentInputColor};
  width: 15px;
  height: 14px;

  display: flex;

  &::before {
    content: "";
    width: 100%;
    height: 100%;
    transform: scale(0);
    background-color: ${(props) => props.theme.colors.previewComponentInputColor};
  }

  &:checked::before {
    transform: scale(1);
  }

  &:focus {
    outline: none;
  }

  box-shadow: none !important;
`;

export const OptionLabel = styled.label`
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
`;

export const Label = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
`;

export const PreviewCardContainer = styled.div`
  width: 100%;
`;

export const PreviewHeader = styled.div`
  width: 100%;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFF;
  background-color: ${(props) => props.theme.colors.previewComponentHeaderBackgroundColor};
`;

export const PreviewWrapper = styled.div`
  background: ${(props) => (props.theme.title === 'light' ? '#F5F6FA' : props.theme.colors.previewComponentBackgroundColor)};
`;

export const ChartContainer = styled.div`
  width: 100% !important;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  position: relative;

  height: 303px;

  &::before {
    content: '';
    border-top: 1px solid ${(props) => (props.theme.title === 'dark' ? '#4C555C' : '#A1B4C4')};
    display: block;

    width: 86%;
    margin-left: 22px;
  }
`;

export const PreviewTitleContainer = styled.div`
  width: 100%;
  min-height: 53px;
  background: transparent;
  padding: 15px 59px 10px 24px;
`;
